import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./legal-document-modal.module.scss";

interface LegalDocumentModalProps {
	title: string;
	onClose: () => void;
	children: React.ReactNode;
}

/**
 * Figma: Legal document sheet — toolbar with left X-in-circle + centered
 * title, scrollable document body with a bottom fade-out gradient.
 */
export const LegalDocumentModal: React.FC<LegalDocumentModalProps> = ({ title, onClose, children }) => {
	const { t } = useTranslation();
	return (
		<div className={styles.overlay} onClick={onClose}>
			<div className={styles.sheet} onClick={e => e.stopPropagation()}>
				<div className={styles.toolbar}>
					<button type="button" className={styles.closeButton} onClick={onClose} aria-label={t("account.web.close")}>
						×
					</button>
					<h2 className={styles.title}>{title}</h2>
				</div>

				<div className={styles.bodyWrap}>
					<div className={styles.body}>
						<div className={styles.document}>{children}</div>
						<div className={styles.bottomSpacer} />
					</div>
					<div className={styles.bottomFade} />
				</div>
			</div>
		</div>
	);
};

export default LegalDocumentModal;
